import React from "react";
import BannerImages from "../../../Common/BannerImages";

export function StartupScreen() {
    const imagePath = React.useMemo(
        () => ["Application", "ImagePublicite", "Logo"],
        []
    );
    return (
        <div className="banner-container">
            <section className="text-section">
                <div className="banner-images">
                    <BannerImages
                        dataPath={imagePath}
                        title="Logo"
                        size="150*150 (png,jpg,jpeg ou webp)"
                    />
                </div>
            </section>
        </div>
    );
}
